/**
 * 자막 글자 크기 순수 함수 — `captionCanvas.ts` ↔ `captionStyleLayout.ts` 순환 의존을 끊기 위해 분리.
 * 이 파일은 어떤 로컬 모듈도 import 하지 않는다.
 */
import { CAPTION_MAX_GRAPHEMES, captionLength } from "@fiket/booth-schema";

export const CAPTION_FONT_PX_MAX = 72;
export const CAPTION_FONT_PX_MIN = 56;
/** 이 글자 수까지는 최대 크기 — 한글 8자 × 72px ≈ 576px 로 720px 띠 폭에 여유 있게 들어간다. */
export const CAPTION_FONT_FULL_SIZE_GRAPHEMES = 8;

/**
 * 자막 글자 크기(px, **띠 120px 기준** — PNG 는 2배이므로 그릴 땐 ×2). 미리보기는 이 값을 띠 높이 대비 비율로 쓴다.
 * 규칙: ≤ 8자 → 72px. 9~12자 → 72 에서 56 까지 선형(1자당 4px). 12자 초과(입력칸이 막지만 방어)는 56px 고정.
 * 비어 있으면 72px(placeholder 용).
 */
export function captionFontPx(text: string): number {
  const n = captionLength(text);
  if (n <= CAPTION_FONT_FULL_SIZE_GRAPHEMES) return CAPTION_FONT_PX_MAX;
  const over = Math.min(n, CAPTION_MAX_GRAPHEMES) - CAPTION_FONT_FULL_SIZE_GRAPHEMES;
  const span = CAPTION_MAX_GRAPHEMES - CAPTION_FONT_FULL_SIZE_GRAPHEMES;
  const px = CAPTION_FONT_PX_MAX - ((CAPTION_FONT_PX_MAX - CAPTION_FONT_PX_MIN) * over) / span;
  return Math.round(px);
}
